<i
  class="far"
  [ngClass]="{
    'fa-check': params.value,
    'fa-times': !params.value && params.value != null
  }"
></i>
